import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";
import SquareChip from "../../square-chip/SquareChip";

export type FormSquareChipProps = {
    header?: string;
    size?: 'small' | 'medium';    
    onChange?: (checked: boolean) => void;
    checkedColorOverride?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'black'    
} & FormFieldPropsBase;

export function FormSquareChip({
    name,
    //id,
    //testId,
    label,
    //ariaLabel,
    //sx,
    disabled,
    onChange,
    header,
    size,
    checkedColorOverride

}: FormSquareChipProps) {

    const { control
        //, getValues 
    } = useFormContext();
    //const initialValue = getValues(name);

    return (
        <>
            <Controller
                control={control}
                name={name}
                render={
                    ({
                        field: { ref, name, value, onChange: onFieldChange, onBlur },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState
                    }: {
                        field: any;
                        fieldState: any;
                        formState: any;
                    }) => (
                        <SquareChip 
                            header={header}
                            label={label}
                            size={size}
                            onClick={(e) => { 
                                onFieldChange(!value);
                                onChange && onChange(!value)
                            }}
                            checked={value as boolean}
                            disabled={disabled}
                            checkedColorOverride={checkedColorOverride}
                        />
                    )
                }
            />

        </>
    );
}

